import { useMutation } from '@tanstack/react-query'
import { useSystemSettingsStore } from '@/store'
import { SystemSettingsParams } from '@/types/setting'

export const useApplySystemSettings = () => {
  const { applySystemSettings } = useSystemSettingsStore()

  return useMutation({
    mutationFn: (data: SystemSettingsParams) => applySystemSettings(data),
    throwOnError: false
  })
}
